<template>
  <div class="table">
    <!--=========查询模块================-->
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="用户名" prop="name">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户账号" prop="emplid">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.emplid"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系邮箱" prop="email">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.email"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="联系电话" prop="phone">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="search">{{$t('common.search')}}</el-button>
            <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>

          </el-row>
        </el-form>
      </div>
      <div class="toolsBox">
        <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
        <el-button type="primary" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
      </div>
      <el-table :data="tableData" ref="pickUserTable" row-key="tmUserId" border style="margin-top:20px" max-height='350' @selection-change="selectionChange" highlight-current-row>
        <el-table-column prop="tmUserId" type="selection" width="55" align="center" :reserve-selection="true" />
        <el-table-column prop="name" label="用户名"></el-table-column>
        <el-table-column prop="emplid" label="用户账号"></el-table-column>
        <el-table-column prop="email" label="联系邮箱"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
      </el-table>
      <div class="pagination">
        <!--===分页组件===-->
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  name: "pickupUser",
  props: {
    nfsArr: String,
    index: Number,
  },
  data() {
    return {
      selectRows: [],
      tableData: [],
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        name: "",
        emplid: "",
        email: '',
        phone: '',
        roleCodes: ['NFC_ADMIN']
      },
      showDialog: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false,
      tmUserIdLists: []
    };
  },
  mounted() {
    this.queryData()
  },
  computed: {
  },
  watch: {
    nfsArr: {
      handler(newVal, oldVal) {
        this.tmUserIdLists = []
        if (newVal) {
          var arr = JSON.parse(newVal)
          this.tmUserIdLists = arr.map(ele => {
            return ele.tmUserId
          })
        }
      },
      immediate: true
    },
    index: {
      handler(newVal, oldVal) {
        this.$nextTick(() => {
          this.selectedDefaultFun()
        });
      },
      immediate: true
    }
  },
  methods: {
    toggleSelection() {
      this.$refs.pickUserTable.clearSelection();
    },
    queryData() {
      userService
        .getUsers(this.queryCondition)
        .then(res => {
          this.$nextTick(() => {
            this.tableData = res.resultData;
            this.totalCount = res.totalCount;
            this.$nextTick(() => {
              this.selectedDefaultFun()
            });
          });
        })
    },
    search() {
      this.queryCondition.pageNum = 1
      this.queryData();
    },
    selectedDefaultFun() {
      //默认选中
      this.tableData.forEach((row, i) => {
        if (this.tmUserIdLists.includes(row.tmUserId)) {
          this.$refs["pickUserTable"].toggleRowSelection(row, true);
        }
      });
    },
    // 确定
    pickUp() {
      console.log("🚀 ~ file: nfsDialog.vue:157 ~ pickUp ~ this.selectRows:", this.selectRows)
      sessionStorage.setItem('selectNfs', JSON.stringify(this.selectRows))
      this.tmUserIdLists = this.selectRows.map(ele => {
        return ele.tmUserId
      })
      this.$emit('getSelNfs')
      // this.$emit("getSelNfs", this.selectRows);
      // this.queryCondition = {
      //   pageSize: 15,
      //   pageNum: 1,
      //   name: "",
      //   emplid: "",
      //   email: '',
      //   phone: '',
      //   roleCodes: ['NFC_ADMIN']
      // }
      // this.tableData = []
    },
    selectionChange(rows) {
      console.log("🚀 ~ file: nfsDialog.vue:188 ~ selectionChange ~ rows:", rows)
      this.selectRows = [];
      this.selectRows = rows
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm: function () {
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        name: "",
        emplid: "",
        email: '',
        phone: '',
        roleCodes: ['NFC_ADMIN']
      }
      this.$refs.pickUserTable.clearSelection();
      this.queryData();
    },
  }
};
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

/*穿梭框样式重写*/
.el-transfer .el-transfer-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 255px;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.el-transfer-panel__body {
  height: 370px;
}

.el-transfer-panel__list.is-filterable {
  height: 360px;
}
</style>
